import { ReactNode, useEffect, useState } from 'react';
import { ButtonGroup } from 'react-daisyui';
import { ButtonGroupProps } from 'react-daisyui/dist/ButtonGroup/ButtonGroup';
import { NavLink, useSearchParams } from 'react-router-dom';
import './AppTabMenu.css';

export type IAppTabMenuGroupProps = ButtonGroupProps;

export const AppTabMenuGroup = ({
  children,
  className,
}: IAppTabMenuGroupProps) => {
  return (
    <ButtonGroup
      className={`btn-group-vertical flex sm:btn-group-horizontal ${className}`}
    >
      {children}
    </ButtonGroup>
  );
};

type ParamType = {
  key: string;
  value: string;
};

export interface IAppTabMenuItemProps {
  defaultTab?: boolean;
  itemCount?: number;
  label: ReactNode | string;
  linkTo?: string;
  paramTo?: ParamType;
  tabToolTip?: string;
}

export const AppTabMenuItem = ({
  defaultTab = false,
  itemCount,
  label,
  linkTo = '',
  paramTo,
  tabToolTip,
}: IAppTabMenuItemProps) => {
  const [searchParams] = useSearchParams();
  const [param, setParam] = useState<string>('');

  useEffect(() => {
    if (!paramTo) return;

    setParam(searchParams.get(paramTo.key) ?? '');
  }, [paramTo, searchParams]);

  return (
    <>
      <NavLink
        id="tab-menu"
        className={({ isActive }) => {
          const isActiveTab = param ? param === paramTo?.value : isActive;

          const highlightedTab =
            !searchParams.get(paramTo?.key ?? '') && paramTo
              ? defaultTab
              : isActiveTab;

          return `btn flex-1 border-none px-0 py-2.5 text-base normal-case hover:bg-secondary ${
            highlightedTab
              ? 'active btn-secondary font-medium text-primary'
              : 'font-normal text-sr-black hover:text-primary'
          }`;
        }}
        replace={true} // Don't add page navigation to history stack
        to={paramTo ? `?${paramTo.key}=${paramTo.value}` : linkTo}
      >
        {label} {itemCount || itemCount !== undefined ? `(${itemCount})` : ''}
      </NavLink>
      {tabToolTip && (
        <p
          className={`absolute z-50 rounded-lg border border-gray-300 bg-white p-4 text-xs text-gray-600 shadow-md xs:!top-1/3 sm:!top-[15%] ${paramTo?.value}`}
        >
          {tabToolTip}
        </p>
      )}
    </>
  );
};

const AppTabMenu = {
  Group: AppTabMenuGroup,
  Item: AppTabMenuItem,
};

export default AppTabMenu;
